<ng-container *ngIf="product$ | async as product">
  <ng-container *ngIf="mainImage$ | async as main">
    <div class="cx-main-image-group" *ngIf="thumbnails$ | async as thumbs">
      <div class="cx-navigate-image">
        <button
          class="btn btn-link"
          [attr.aria-label]="'productImageZoomDialog.previousSlide' | cxTranslate"
          [attr.title]="'productImageZoomDialog.previousSlide' | cxTranslate"
          *ngIf="getPreviousProduct(thumbs) | async as previousProduct"
          (click)="openImage(previousProduct.container)"
        >
          <cx-icon [type]="iconType.CARET_LEFT"></cx-icon>
        </button>
      </div>
      <!-- TODO: (CXSPA-7492) - Remove feature flag next major release. -->
      <div *cxFeature="'a11yKeyboardAccessibleZoom'" class="cx-image-container">
        <cx-media
          #defaultImage
          class="cx-default-image-zoom"
          (loaded)="onImageLoad()"
          *ngIf="!isZoomed"
          [container]="main"
        >
        </cx-media>
        <div #zoomContainer class="cx-zoom-container" *ngIf="isZoomed">
          <cx-media
            #zoomedImage
            class="cx-image-zoomed"
            [container]="main"
            (mousemove)="pointerMove($event)"
            (touchmove)="touchMove($event)"
            (touchend)="clearTouch()"
            (loaded)="onImageLoad()"
          >
          </cx-media>
        </div>
        <button
          #zoomButton
          *ngIf="imageLoaded | async"
          [attr.aria-label]="
            isZoomed
              ? ('common.zoomOut' | cxTranslate)
              : ('common.zoomIn' | cxTranslate)
          "
          title="{{
            isZoomed
              ? ('common.zoomOut' | cxTranslate)
              : ('common.zoomIn' | cxTranslate)
          }}"
          class="btn btn-link cx-zoom-btn"
          (click)="zoom()"
        >
          <cx-icon
            [type]="iconType.SEARCH_PLUS"
            *ngIf="!isZoomed"
            class="cx-zoom-indicator"
          ></cx-icon>
          <cx-icon
            [type]="iconType.SEARCH_MINUS"
            *ngIf="isZoomed"
            class="cx-zoom-indicator"
          ></cx-icon>
        </button>
      </div>
      <ng-container *cxFeature="'!a11yKeyboardAccessibleZoom'">
        <cx-media
          #defaultImage
          class="cx-default-image-zoom"
          *ngIf="!isZoomed"
          [container]="main"
          [alt]="product?.name" 
          [title]="product?.name"
        >
        </cx-media>
        <div #zoomContainer class="cx-zoom-container" *ngIf="isZoomed">
          <cx-media
            #zoomedImage
            class="cx-image-zoomed"
            [container]="main"
            (mousemove)="pointerMove($event)"
            (touchmove)="touchMove($event)"
            (touchend)="clearTouch()"
            [alt]="product?.name" 
            [title]="product?.name"
          >
          </cx-media>
        </div>
      </ng-container>
      <div class="cx-navigate-image">
        <button
          class="btn btn-link"
          [attr.aria-label]="'productImageZoomDialog.nextSlide' | cxTranslate"
          [attr.title]="'productImageZoomDialog.nextSlide' | cxTranslate"
          *ngIf="getNextProduct(thumbs) | async as nextProduct"
          (click)="openImage(nextProduct.container)"
        >
          <cx-icon [type]="iconType.CARET_RIGHT"></cx-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <gen-product-image-zoom-thumbnails
    [productName]="product.name"
    [thumbs$]="thumbnails$"
    [activeThumb]="activeThumb"
    (productImage)="changeImage($event)">
  </gen-product-image-zoom-thumbnails>
</ng-container>